import React from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';

function AgentsComponent() {
    // Use useSelector hook to access Redux state
    const users = useSelector(state => state.users.users);
    const sessions = useSelector(state => state.sessions.sessions);
    const supportDesks = useSelector(state => state.services.supportDesks);
    const fbOptions = useSelector(state => state.fb.fbOptions);

    var onlineAgents = [];
    var offlineAgents = [];
    
    // Make sure users array exists before iterating
    if (users && Array.isArray(users)) {
        users.forEach(data => {
            // Skip if data is null or id is missing
            if (!data || !data.id) return;
            
            var session = sessions && Array.isArray(sessions) ? 
                sessions.find(session => session && session.userId === data.id) : null;
                
            if(!_.isEmpty(session)){
                if(Number(session.status) === 1){
                    var supportDesk = supportDesks && Array.isArray(supportDesks) ? 
                        supportDesks.find(desk => desk && desk.id === session.supportDeskId) : null;
                    var supportDeskType = supportDesk?.type || ""
                    var supportDeskNumber = supportDesk?.number || ""
                    onlineAgents.push({ 
                        ...data, 
                        supportDeskId: session.supportDeskId || "", 
                        supportDeskType, 
                        supportDeskNumber 
                    })
                } else {
                    offlineAgents.push({ ...data, reason: session.reason || "" })
                }
            } else {
                offlineAgents.push({ ...data, reason: "" })
            }
        });
    }

    return(
        <div className="home-left-content5-wraper">
            <div className="titleBlock">
                <h4>{onlineAgents.length} Agent { onlineAgents.length !== 1 ? 's' : '' } Online</h4>
            </div>
            <div className="usersListContainer">
                <div className="user-list-online">
                {onlineAgents && onlineAgents.map((data, index) => {
                    if (!data) return null;
                    
                    var inititals = "";
                    if (data.name && data.lastname) {
                        inititals = (data.name || "").toString()
                            .replace(/[&/\\#,+()$~%.'":*?!<>{}]/g,'')
                            .charAt(0) 
                            + 
                            (data.lastname || "").toString()
                            .replace(/[&/\\#,+()$~%.'":*?!<>{}]/g,'')
                            .charAt(0);
                    }
                    
                    return(
                        <div className="user-list" key={index} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', height: 'auto', alignItems: 'center', marginBottom: '8px'}}>
                            <div className="user-name-and-pic">
                                <div>
                                    <div>
                                        <span className="status-badge"></span>
                                        <span className="user-image-text">{ inititals }</span> 
                                    </div>
                                    <p>{ (data.name || "") + " " + (data.lastname || "") }</p>
                                </div>
                            </div>
                            <div className="user-list-content"><p>{ (data.supportDeskType || "") + " " + (data.supportDeskNumber || "") }</p></div>
                        </div>
                    );
                })}
                </div>

                <div className="user-list-offline">
                {offlineAgents && offlineAgents.map((data, index) => {
                    if (!data) return null;
                    
                    var inititals = "";
                    if (data.name && data.lastname) {
                        inititals = (data.name || "").toString()
                            .replace(/[&/\\#,+()$~%.'":*?!<>{}]/g,'')
                            .charAt(0) 
                            + 
                            (data.lastname || "").toString()
                            .replace(/[&/\\#,+()$~%.'":*?!<>{}]/g,'')
                            .charAt(0);
                    }

                    return(
                        <div className="user-list" key={index} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', height: 'auto', alignItems: 'center', marginBottom: '8px'}}>
                            <div className="user-name-and-pic">
                                <div>
                                    <div>
                                        <span className="status-badge"></span>
                                        <span className="user-image-text">{ inititals }</span> 
                                    </div>
                                    <p>{ (data.name || "") + " " + (data.lastname || "") }</p>
                                </div>
                            </div>
                            <div className="user-list-content"><p>
                            { 
                                data.reason && data.reason.length
                                    ? (fbOptions && Array.isArray(fbOptions) 
                                        ? fbOptions.find(options => options && options.id === data.reason)?.name || "Unknown"
                                        : "Unknown")
                                    : "Never signed in"
                            }
                            </p></div>
                        </div>
                    );
                })}
                </div>
            </div>
        </div>
    )
}

export default AgentsComponent;